<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 class="card-title">Sistem Kullanıcıları</h4>
                  <p class="card-category">Paneli kullanacak olan kullanıcıları buradan daha kolay yönetebilirsiniz.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="createNew()">
                    Yeni Oluştur
                  </button>
                </div>

              </div>
            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" :key="index">
                  <slot :row="user">
                    <td>{{ user.name }}</td>
                    <td>{{ user.surname }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.role }}</td>
                    <td>{{ user.dealers ? user.dealers.map(dealer => dealer.dealerId.title).join(', ') : 'Yok' }}</td>
                    <td>{{ user.isActive ? 'Evet' : 'Hayır' }}</td>
                    <td @click="openDeleteModal(user)"><button><i class="nc-icon nc-simple-remove"></i></button></td>
                    <td @click="editUser(user._id)"><button><i class="nc-icon nc-settings-tool-66"></i></button>
                    </td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)" :key="i"><a
                    class="page-link">{{ i +
                      1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>


        <div class="modal fade show bg-gray" tabindex="-1"
          :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="deleteModal.company">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Şirketi silmek istediğinize emin misiniz? Durumu
                  pasife
                  çekerek gizleyebilirsiniz.</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="deleteModal.isOpened = false">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="modal-body">
                <label><strong>Şirket Adı:</strong> {{ deleteModal.company.title }}</label><br>
                <label><strong>Ülke:</strong> {{ deleteModal.company.country }}</label><br>
                <label><strong>Şehir:</strong> {{ deleteModal.company.city }}</label><br>

              </div>
              <div class="modal-footer">

                <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="deleteCompany(deleteModal.company._id)"
                  class="btn btn-primary">Sil!</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";


const tableColumns = ['İsim', 'Soyisim', 'E-Posta', 'Rol', 'Bağlı Olduğu Bayi', 'Aktif mi?', 'Sil', 'Düzenle']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      users: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      deleteModal: {
        isOpened: false,
        user: null
      },
      searchInterval: null
    }
  },
  mounted() {
    this.getUsers();

  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getUsers();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getUsers() {
      let q = { };
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('users', query).then((res) => {
        if (res.success == true) {
          this.users = res.users;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      })
    },
    deleteUser(_id) {
      CollectionService.deleteItem('users', _id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${this.deleteModal.user.name} kullanıcı silindi.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.user = null;
        this.getUsers();
      })
    },
    openDeleteModal(user) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.user = user;
    },
    editUser(_id) {
      this.$router.push(`/admin/users/${_id}`);
    },
    createNew() {
      this.$router.push(`/admin/users/create`);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    }
  }
}
</script>
<style></style>